// Entry point for javascript creates a router to handle new routes and adds a view inside the Product Details Page

define(
	'GoVirtualOffice.LoginOriginRedirect.LoginOriginRedirect',
	[],
	function ()
{
	'use strict';

	return  {
		mountToApp: function mountToApp (application) {

			var layout;
			var environment;
			var config;

			layout = application.getComponent('Layout');
			environment = application.getComponent('Environment');

			config = environment && environment.getConfig('digiConfigSettings.register') || {};

			if (layout && config.enableLoginOriginRedirect) {

				layout.addToViewEventsDefinition('Header.Profile.View', 'click [data-action="add-origin-hash"]', function(e) {

					var response;
					var currentPath;
					var originalLoginHref = e.currentTarget.href;
					var currentHref = window.location.href;

					response = true;

					// We only continue if the original login href does not already contain origin_hash
					if (originalLoginHref.indexOf('orign_hash') === -1) {

						// Handles local URL paths
						if (currentHref.indexOf('#') !== -1 || currentHref.indexOf('-local.ssp') !== -1) {
							currentPath = currentHref.split('#')[1] || '/';
						} else {
							currentPath = window.location.pathname;
						}

						if (currentPath) {
							window.location.href = originalLoginHref + '&origin=home&origin_hash=' + currentPath;
							response = false;
						}
					}

					return response;
				});
			}
		}
	};
});
